import { Chain } from 'thirdweb/chains'
import {
  arbitrumSepoliaChainConfig,
  arbitrumSepoliaEnvironment,
} from './arbitrum-sepolia'
import { baseChainConfig, baseEnvironment } from './base'
import { ethereumChainConfig, ethereumEnvironment } from './ethereum'
import { polygonChainConfig, polygonEnvironment } from './polygon'

export enum SupportedChainId {
  Mainnet = ethereumChainConfig.id,
  Base = baseChainConfig.id,
  Polygon = polygonChainConfig.id,
  ArbitrumSepolia = arbitrumSepoliaChainConfig.id,
}

export const mainNetworks: Chain[] = [
  polygonChainConfig,
  ethereumChainConfig,
  baseChainConfig,
]

export const testNetworks: Chain[] = [arbitrumSepoliaChainConfig]

export const allNetworks = [...mainNetworks, ...testNetworks]

export const networksEnvironments = {
  [SupportedChainId.Mainnet]: ethereumEnvironment,
  [SupportedChainId.Base]: baseEnvironment,
  [SupportedChainId.Polygon]: polygonEnvironment,
  [SupportedChainId.ArbitrumSepolia]: arbitrumSepoliaEnvironment,
}
